import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { FeaturedCollections } from './components/FeaturedCollections';
import { LimitedEditions } from './components/LimitedEditions';
import { ValueProps } from './components/ValueProps';
import { ProductGrid } from './components/ProductGrid';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F0] font-sans selection:bg-[#C9A962] selection:text-[#0A0A0A]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <FeaturedCollections data-id="element-4" />
        <LimitedEditions data-id="element-5" />
        <ValueProps data-id="element-6" />
        <ProductGrid data-id="element-7" />
        <Newsletter data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}